import { FacetLoadingStateService } from './../common/facet/facet-loading-state.service';
import { map } from 'rxjs/operators';
import {
    Component,
    Input,
    OnInit,
    OnChanges,
} from '@angular/core';

import { OrderVocabService } from './order-vocab.service';

import { PrivilegeService } from '../services/privilege.service';
import { SampleOrder } from '@common/types';

@Component({
    selector: 'sample-order-detail',
    templateUrl: './sample-order-detail.component.html',
    styles: [`
        
    `]
})
export class SampleOrderDetailComponent implements OnInit, OnChanges {
    @Input() order: string;
    @Input() sampleOrder: SampleOrder;

    // CVs
    sampleConditions: any[] = [];
    taxons: any[] = [];
    sampleTypes: any[] = [];

    // State
    readonly COMPONENT_LOG_TAG = 'sample-order-detail';

    readwrite: boolean;
    readonly: boolean;
    contactsShown: boolean;

    constructor(
        private privilegeService: PrivilegeService,
        private facetLoadingStateService: FacetLoadingStateService,
        private orderVocabService: OrderVocabService,
    ) { }

    // lifecycle
    ngOnInit() {

        this.initialize();
    }

    ngOnChanges(changes: any) {
        if (changes.entity && !changes.entity.firstChange) {
            this.initialize();
        }
    }

    initialize() {
        this.facetLoadingStateService.changeLoadingState(true);

        this.setPrivileges();

        return this.getCVs().then(() => {
            this.facetLoadingStateService.changeLoadingState(false);
        }).catch((error) => {
            this.facetLoadingStateService.changeLoadingState(false);
            throw error;
        });
    }

    private getCVs(): Promise<any> {
        const p1 = this.orderVocabService.sampleConditions$.pipe(map((data) => {
            this.sampleConditions = data;
        })).toPromise();

        const p2 = this.orderVocabService.taxons$.pipe(map((data) => {
            this.taxons = data;
        })).toPromise();

        const p3 = this.orderVocabService.sampleTypes$.pipe(map((data) => {
            this.sampleTypes = data;
        })).toPromise();

        return Promise.all([p1, p2, p3]);
    }

    /**
     * Sets privilege variables.
     */
    private setPrivileges() {
        this.readonly = this.privilegeService.readonly;
        this.readwrite = this.privilegeService.readwrite;
    }

    // Formatters for <select> input
    sampleConditionKeyFormatter = (value: any) => {
        return value.C_SampleCondition_key;
    }
    sampleConditionFormatter = (value: any) => {
        return value.SampleCondition;
    }

    sampleTypeKeyFormatter = (value: any) => {
        return value.C_SampleType_key;
    }
    sampleTypeFormatter = (value: any) => {
        return value.SampleType;
    }

    taxonKeyFormatter = (value: any) => {
        return value.C_Taxon_key;
    }
    taxonFormatter = (value: any) => {
        return value.Taxon;
    }
}
